import _asyncToGenerator from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
export default {
  props: {
    options: Object,
    propValue: [String, Number]
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.initItems();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    initItems: function initItems() {
      this.$set(this.options, 'items', [{
        text: '',
        value: ''
      }, {
        text: this.$i18n('grid.select.yes'),
        value: '1'
      }, {
        text: this.$i18n('grid.select.no'),
        value: '0,'
      }]);
    },
    changeHandle: function changeHandle(fieldName, value, rowIndex, oldValue, text, activeItem) {
      this.$emit('change', {
        value: value,
        text: text,
        activeItem: activeItem,
        match: 'IN'
      });
    }
  }
};